/** Estados en los que el paquete (S1, S2…) ya no debe modificarse. */
export const SERVICE_PACKAGE_LOCKED_STATUSES = [
  'En curso',
  'Completado',
  'Finalizado',
  'Cancelado',
];

/** Hasta iniciar servicio (En curso): se puede cambiar el paquete de mantenimiento. */
export function canChangeServicePackageBeforeStart(
  statusName,
  { serviceStart } = {},
) {
  if (serviceStart) return false;
  const status = String(statusName || '').trim();
  if (SERVICE_PACKAGE_LOCKED_STATUSES.includes(status)) return false;
  return true;
}
